import { IconButton, IconButtonProps, Tooltip } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import type { Dashboard } from 'lib-analytics-types';
import { HTMLDataAttributes } from 'lib-shared-types-utils';
import { MouseEvent, useMemo } from 'react';

type AnalyticsDocumentationButtonProps =
  | {
      type: 'dashboard';
      dashboard: Dashboard;
      articleId?: never;
    }
  | {
      type: 'article';
      dashboard?: never;
      articleId: string;
    };

export const AnalyticsDocumentationButton = ({
  type,
  dashboard,
  articleId,
}: AnalyticsDocumentationButtonProps): JSX.Element => {
  const iconButtonProps = useMemo((): Partial<IconButtonProps> &
    HTMLDataAttributes<string> => {
    switch (type) {
      case 'dashboard':
        return {
          'data-analytics-dashboard-helper': dashboard.id,
          'data-elevio-allow-propagation': true,
        };

      case 'article':
      default:
        return {
          onClick: (e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            elevioClient.openArticle(articleId);
          },
        };
    }
  }, [articleId, dashboard?.id, type]);

  return (
    <Tooltip content="Help and documentation">
      <IconButton icon="question" variant="tertiary" {...iconButtonProps} />
    </Tooltip>
  );
};
